import React from 'react';
import { ClipboardList, Microscope, Users, FileText, UserCheck, CalendarCheck } from 'lucide-react';
import styles from './ProfessorWelcome.module.css';

const steps = [
  { icon: ClipboardList, label: 'Basic Information', timeEstimate: '30 sec' },
  { icon: Microscope, label: 'Research Interests', timeEstimate: '45 sec' },
  { icon: FileText, label: 'Create Positions', timeEstimate: '5 min' },
  { icon: Users, label: 'Review Applications', timeEstimate: 'Varies' },
  { icon: UserCheck, label: 'Select Candidates', timeEstimate: '10 min' },
  { icon: CalendarCheck, label: 'Schedule Interviews', timeEstimate: '5 min' },
];

function ProgressTimeline({ currentStep, completedSteps }) {
  const getStepStatus = (index) => {
    if (completedSteps.has(index)) return 'completed';
    if (index === currentStep) return 'current';
    return 'pending';
  };

  return (
    <div className={styles.timelineContainer}>
      <div className={styles.progressLine}>
        <div
          className={styles.progressFill}
          style={{ width: `${(currentStep / (steps.length - 1)) * 100}%` }}
        ></div>
      </div>
      {steps.map((step, index) => {
        const status = getStepStatus(index);
        return (
          <div key={index} className={styles.stepItem}>
            <div
              className={`${styles.stepIcon} ${
                status === 'completed'
                  ? styles.stepIconCompleted
                  : status === 'current'
                  ? styles.stepIconCurrent
                  : styles.stepIconPending
              }`}
            >
              <step.icon
                className="w-5 h-5"
                color={status !== 'pending' ? 'white' : '#061941'}
              />
            </div>
            <span className={styles.stepLabel}>
              {step.label}
            </span>
            <div
              className={`${styles.stepDot} ${
                status !== 'pending' ? styles.stepDotActive : styles.stepDotInactive
              }`}
            ></div>
            <div className={styles.stepNumber}>{index + 1}</div>
            <div className={styles.timeEstimate}>{step.timeEstimate}</div>
          </div>
        );
      })}
    </div>
  );
}

export default ProgressTimeline;